module.exports = __webpack_public_path__ + "img/MoonSword 3.e2e12cdb.png";